import { NgModule } from '@angular/core';
import { CommonModule } from '../common/common.module';
import { CoreModule } from '../core/core.module';
import { LettingAdvertismentBoplatsSverigeComponent } from './component/letting-advertisment-boplats-sverige/letting-advertisment-boplats-sverige.component';
import { LettingAdvertismentFormComponent } from './component/letting-advertisment-form/letting-advertisment-form.component';
import { LettingAdvertismentHomeqComponent } from './component/letting-advertisment-homeq/letting-advertisment-homeq.component';
import { LettingAdvertismentMarketAreaComponent } from './component/letting-advertisment-market-area/letting-advertisment-market-area.component';
import { LettingAdvertismentMarketComponent } from './component/letting-advertisment-market/letting-advertisment-market.component';
import { LettingAdvertismentParkingFormComponent } from './component/letting-advertisment-parking-form/letting-advertisment-parking-form.component';
import { LettingAdvertismentPremisesFormComponent } from './component/letting-advertisment-premises-form/letting-advertisment-premises-form.component';
import { LettingDocumentControlComponent } from './component/letting-document-control/letting-document-control.component';
import { LettingFeatureControl } from './component/letting-feature-control/letting-feature-control.component';
import { LettingUnpublishedWarningComponent } from './component/letting-unpublished-warning/letting-unpublished-warning.component';
import { SendToPlatformCommandHandler } from './service/command/send-to-platform-command-handler.service';
import { SendToPlatformParkingCommandHandler } from './service/command/send-to-platform-parking-command-handler.service';
import { SendToPlatformPremisesCommandHandler } from './service/command/send-to-platform-premises-command-handler.service';
import { LettingAdvertismentGuard } from './service/guard/letting-advertisment-guard.service';
import { LettingAdvertismentOrdinaryService } from './service/letting-advertisment-ordinary.service';
import { LettingAdvertismentParkingService } from './service/letting-advertisment-parking.service';
import { LettingAdvertismentPremisesService } from './service/letting-advertisment-premises.service';
import { LettingAdvertismentService } from './service/letting-advertisment.service';

@NgModule({
  imports: [CommonModule, CoreModule],
  declarations: [
    LettingAdvertismentFormComponent,
    LettingAdvertismentBoplatsSverigeComponent,
    LettingAdvertismentHomeqComponent,
    LettingAdvertismentMarketAreaComponent,
    LettingAdvertismentMarketComponent,
    LettingAdvertismentParkingFormComponent,
    LettingAdvertismentPremisesFormComponent,
    LettingDocumentControlComponent,
    LettingFeatureControl,
    LettingUnpublishedWarningComponent,
  ],
  providers: [
    LettingAdvertismentGuard,
    LettingAdvertismentOrdinaryService,
    LettingAdvertismentParkingService,
    LettingAdvertismentPremisesService,
    LettingAdvertismentService,
    SendToPlatformCommandHandler,
    SendToPlatformParkingCommandHandler,
    SendToPlatformPremisesCommandHandler,
  ],
  exports: [],
})
export class LettingModule {}
